import { render, staticRenderFns } from "./MerchantSidebar.vue?vue&type=template&id=9a6f14fe&scoped=true"
import script from "./MerchantSidebar.vue?vue&type=script&lang=js"
export * from "./MerchantSidebar.vue?vue&type=script&lang=js"
import style0 from "./MerchantSidebar.vue?vue&type=style&index=0&id=9a6f14fe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a6f14fe",
  null
  
)

export default component.exports